// extracted by mini-css-extract-plugin
export default {"inbodyKeyCell":"_2R8qKBjZznpIXvLD0RG"};